import { Injectable } from '@angular/core';
import { DataShareService } from './data-share.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AutocompleteService {
  constructor(
    private dataShare: DataShareService,
    private spinner: NgxSpinnerService
  ) {}

processAutocomplete(selectedData: any, type: string, activeType: string) {
  if (!selectedData || !selectedData.data) {
    return;
  }

  var locationObj = {
    region: '',
    area: '',
    includeSurroundingSuburbs: false,
    postCode: '',
    state: '',
    suburb: '',
    lat: selectedData.data.geometry && selectedData.data.geometry.location ? selectedData.data.geometry.location.lat : null,
    lng: selectedData.data.geometry && selectedData.data.geometry.location ? selectedData.data.geometry.location.lng : null
  };

  var unitNumber = '';
  var streetNumberStr = '';
  var routeNameStr = '';
  var suburbFlag = 0;
  var stateFlag = 0;
  var postCodeFlag = 0;
  var streetNumberFlag = 0;
  var routeFlag = 0;

  // Process address components
  if (
    selectedData.data.address_components &&
    Array.isArray(selectedData.data.address_components) &&
    selectedData.data.address_components.length > 0
  ) {
    selectedData.data.address_components.forEach(function(component: any) {
      var addressType = component.types;
      if (addressType.indexOf('street_number') >= 0) {
        streetNumberStr = component.long_name;
        streetNumberFlag = 1;
      }
      if (addressType.indexOf('route') >= 0) {
        routeNameStr = component.long_name;
        routeFlag = 1;
      }
      if (addressType.indexOf('postal_code') >= 0) {
        locationObj.postCode = component.long_name;
        postCodeFlag = 1;
      }
      if (addressType.indexOf('administrative_area_level_1') >= 0) {
        locationObj.state = component.short_name;
        stateFlag = 1;
      }
      if (addressType.indexOf('locality') >= 0) {
        locationObj.suburb = component.long_name;
        suburbFlag = 1;
      }
      if (addressType.indexOf('country') >= 0) {
        locationObj.region = component.long_name;
      }
    });
  }

  // Extract unit number from formatted_address (if present)
  // const formatted = selectedData.data.formatted_address;
  // const unitRegex = /^([\dA-Za-z\-]+)\/[\d]/;
  // const unitMatch = formatted.match(unitRegex);
  // if (unitMatch && unitMatch[1]) {
  //   unitNumber = unitMatch[1];
  // }
  // if (unitNumber && streetNumberStr && routeNameStr) {
  //   locationObj.area = `${unitNumber}/${streetNumberStr} ${routeNameStr}`;
  // } else {
  //   locationObj.area = `${streetNumberStr} ${routeNameStr}`;
  // }

  // Reset empty fields
  locationObj.area = selectedData.data.name || '';
  locationObj.suburb = suburbFlag ? locationObj.suburb : '';
  locationObj.postCode = postCodeFlag ? locationObj.postCode : '';
  locationObj.state = stateFlag ? locationObj.state : '';

  // Store data based on type
  switch (type) {
    case 'global':
      this.handleGlobalType(selectedData, locationObj, activeType);
      break;
    case 'sr_address':
      this.handleSrAddressType(selectedData);
      break;
    case 'trade':
      this.handleTradeType(selectedData, locationObj);
      break;
    case 'trade_by_suburb':
      this.handleTradeBySuburb(selectedData, locationObj);
      break;
    case 'agent':
      this.handleAgentType(selectedData);
      break;
    default:
      console.warn('Unknown type:', type);
  }
}

  private handleGlobalType(selectedData: any, locationObj: any, activeType: string) {
    this.dataShare.search_Title(selectedData.data.description);
    localStorage.setItem('searchTitle', selectedData.data.description);

    var searchObj = {
      listingType: activeType || '',
      locations: [locationObj],
      page: 1,
      pageSize: 10,
      type: 'PropertyListing'
    };

    // Store search object in DataShareService instead of navigating
    this.dataShare.changeSearchObj(searchObj);
    localStorage.setItem('search_obj', JSON.stringify(searchObj));
  }

  private handleSrAddressType(selectedData: any) {
    var reqAddress = {
      lat: selectedData.data.geometry && selectedData.data.geometry.location ? selectedData.data.geometry.location.lat : null,
      lng: selectedData.data.geometry && selectedData.data.geometry.location ? selectedData.data.geometry.location.lng : null,
      address: selectedData.data.formatted_address || null
    };
    this.dataShare.updateReqAddress(reqAddress);
  }

  private handleTradeType(selectedData: any, locationObj: any) {
    var tradeAddress = {
      lat: selectedData.data.geometry && selectedData.data.geometry.location ? selectedData.data.geometry.location.lat : null,
      lng: selectedData.data.geometry && selectedData.data.geometry.location ? selectedData.data.geometry.location.lng : null,
      address: selectedData.data.formatted_address || null,
      location: locationObj
    };
    this.dataShare.updateTradeAddress(tradeAddress);
    localStorage.setItem('trader_data_obj', JSON.stringify(tradeAddress));
  }
  private handleTradeBySuburb(selectedData: any, locationObj: any) {
    const { area, ...cleanedLocationObj } = locationObj;
    var tradeAddress = {
      postCode: cleanedLocationObj.postCode || null,
      // lat: selectedData.data.geometry && selectedData.data.geometry.location ? selectedData.data.geometry.location.lat : null,
      // lng: selectedData.data.geometry && selectedData.data.geometry.location ? selectedData.data.geometry.location.lng : null,
      suburbOrState: cleanedLocationObj.suburb || cleanedLocationObj.state || null,
      suburb: cleanedLocationObj.suburb || null,
      state: cleanedLocationObj.state || null,
      location: cleanedLocationObj
    };
    this.dataShare.updateTradeAddress(tradeAddress);
    localStorage.setItem('trader_data_obj', JSON.stringify(tradeAddress));
  }

  private handleAgentType(selectedData: any) {
    var agentFilter = { city: '' };
    if (
      selectedData.data.address_components &&
      Array.isArray(selectedData.data.address_components) &&
      selectedData.data.address_components.length > 0
    ) {
      var locality = selectedData.data.address_components.filter(function(component: any) {
        return component.types.indexOf('locality') >= 0;
      })[0];
      if (locality) {
        agentFilter.city = locality.long_name;
      }
    }

    this.dataShare.search_Title(selectedData.data.description);
    localStorage.setItem('searchTitle', selectedData.data.description);
    this.dataShare.changeAgentSearchObj(agentFilter);
    localStorage.setItem('agent_search_obj', JSON.stringify(agentFilter));
  }

  triggerNavigation(type: string, router: any) {
    this.spinner.show('outer');
    var self = this;
    setTimeout(function() {
      if (type === 'global' || type === 'sr_address') {
        router.navigate(['/property_list']);
      } else if (type === 'agent') {
        router.navigate(['/agent_list']);
      } else if (type === 'trade' || type === 'trade_by_suburb') {
        router.navigate(['/trader_list']);
      }
      self.spinner.hide('outer');
    }, 1000);
  }
}